// eslint-disable-next-line import/no-anonymous-default-export
export default {
  payments: 'Ödemeler',
  // Header specific
  selectLanguage: 'Dil Seçin',
  confirmLogout: 'Çıkış yapmak istediğinizden emin misiniz?',
  lightMode: 'Açık Moda Geç',
  darkMode: 'Koyu Moda Geç',
  logout: 'Çıkış Yap',
  user: 'Kullanıcı'
};
